export default __webpack_public_path__ + "static/media/loading.4f994b6c.gif";